<template>
  <q-page class="login-page flex flex-center">
    <div class="login-box">

      <!-- <div class="close-row">
  <q-btn
    flat
    round
    dense
    icon="close"
    color="grey-7"
    @click="$router.push('/najava')"
  />
</div> -->

      <div class="text-center q-mb-md">
        <img :src="require('@/assets/logo.png')" class="logo" />
        <h6 class="text-mint text-bold q-mt-md">Најава за вработени</h6>
      </div>

      <q-form @submit.prevent="najava" class="q-gutter-md q-mt-md">

        <q-input
          v-model="username"
          type="text"
          label="Корисничко име"
          outlined
          color="mint"
          dense
          clearable
        >
          <template v-slot:prepend>
            <q-icon name="person" color="mint" />
          </template>
        </q-input>

        <q-input
          v-model="pass"
          :type="showPass ? 'text' : 'password'"
          label="Лозинка"
          outlined
          dense
          color="mint"
        >
          <template v-slot:prepend>
            <q-icon name="lock" color="mint" />
          </template>

          <template v-slot:append>
            <q-icon
              :name="showPass ? 'visibility_off' : 'visibility'"
              class="cursor-pointer text-mint"
              @click="showPass = !showPass"
            />
          </template>
        </q-input>

        <div class="text-center q-mt-md">
          <q-btn
            label="Најави се"
            type="submit"
            icon="login"
            class="btn-login"
            :loading="loading"
            unelevated
            rounded
          />
        </div>

        <div v-if="err" class="text-negative text-center text-caption q-mt-sm">
          {{ err }}
        </div>

      </q-form>
    </div>
  </q-page>
</template>

<script>
import { loginVraboten } from "@/services/authService";

export default {
  name: "Najava",

  data() {
    return {
      username: "",
      pass: "",
      showPass: false,
      err: "",
      loading: false,
    };
  },

  methods: {
    async najava() {
      this.err = "";

      if (!this.username || !this.pass) {
        this.err = "Пополнете ги сите полиња.";
        return;
      }

      this.loading = true;

      try {
        const data = await loginVraboten(this.username, this.pass);
        console.log("data", data)
        // ако API враќа user или token → снимаме
        const korisnik = {
          username: data.username || this.username,
          id: data.Id || "",
          ime: data.Name || "",
          uloga: data.uloga || "Vraboten",
          token: data.token || null,
          loginAt: Date.now(),
        };

        localStorage.setItem("user", JSON.stringify(korisnik));

        // this.$q.notify({
        //   color: "positive",
        //   message: `Добредојде, ${korisnik.ime}!`,
        //   icon: "check",
        // });

        this.$router.replace("/vraboten");

      } catch (err) {
        this.err = err.message || "Неточни податоци за најава.";
      }

      this.loading = false;
    },
  },
};
</script>


<style scoped>
/* === Позадина === */
.login-page {
  min-height: 100vh;
  background-color: #eef2f3;
}

/* === Централна кутија === */
.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  padding: 40px 34px;
  transition: all 0.3s ease;
}
.login-box:hover {
  box-shadow: 0 10px 30px rgba(14, 107, 95, 0.25);
  transform: translateY(-3px);
}

/* === Лого === */
.logo {
  width: 210px; 
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(14, 107, 95, 0.3));
  margin-bottom: 10px;
}

/* === Копче === */
.btn-login {
  background-color: #0e6b5f !important;
  color: #ffffff !important;
  font-weight: 600;
  font-size: 15px;
  padding: 9px 0;
  width: 85%;
  transition: all 0.25s ease;
}
.btn-login:hover {
  background-color: #0b5e54 !important;
  box-shadow: 0 4px 12px rgba(14, 107, 95, 0.3);
}

/* === Фокус полиња === */
.q-field--focused .q-field__control {
  border-color: #0e6b5f !important;
  box-shadow: 0 0 0 2px rgba(14, 107, 95, 0.15);
}

/* === Текст и боја === */
.text-mint {
  color: #0e6b5f !important;
}

/* === Responsive === */
@media (max-width: 600px) {
  .login-box {
    width: 90%;
    padding: 28px 22px;
  }
  .logo {
    width: 170px;
  }
  .btn-login {
    width: 100%;
  }
}
.close-row {
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
  margin-right: -10px;
}
</style>
